<section class="class-component" [class.class-component__active]="setPrivilege" [class.habirint-active]="lesson?.is_habirint">
  <div class="class-component__header">
    <span class="class-component__header__in-lesson">
      на уроке
    </span>
    <span *ngIf="isTeach && privilegeSettings.length > 0"
      class="class-component__header__privilege">
      <span class="class-component__header__privilege__toggle">
        <button mat-button (click)="clickSetPrivilege()">
          Привилегии
          <mat-icon inline=true>keyboard_tab</mat-icon>
        </button>
      </span>
      <span *ngIf="isTeach && setPrivilege"
        class="class-component__header__privilege__icons">
        <div *ngFor="let priv of privilegeSettings;"
            class="class-component__header__privilege__icons__item">
            <img
              [src]="main_domain + priv.character.icon_url"
              [alt]="priv.character.title"
              [title]="priv.privilege.title">
          </div>
      </span>
    </span>
  </div>  
  <div class="class-component__body" [class.privilege-active]="setPrivilege">
    <div *ngIf="selectedStudent">
      <app-pupil
        [pupil]="selectedStudent"
        [pupilId]="selectedStudent.id"
        [pupilIndex]="selectedStudentIndex"
        [lesson]="lesson"
        [isTeach]="isTeach"
        (closePupilCard)="deselectPupil()">
      </app-pupil>
    </div>
    <ul class="class-component__body__list" *ngIf="students">
      <li *ngFor="let student of students; let sIndex = index;"
        class="class-component__body__list__item" [class.habirint-active]="lesson?.is_habirint">
        <span class="class-component__body__list__item__student">
          <span class="class-component__body__list__item__student__absent">
            <app-absent class="pupil_list__absent-btn"
              [lesson]="lesson" [student]="student" *ngIf="lesson">
            </app-absent>
          </span>
          <span class="class-component__body__list__item__student__info" 
            [class.active-student]="isStudentPresent(student.id)"
            [class.selected-student]="showPupilInfo === student.id"
            (click)="definePupil(student.id)">
            <span>{{ sIndex + 1 }}. </span>
            <span> {{ student.surname }} {{ student.name }}</span>
          </span>
        </span>
        <span class="class-component__body__list__item__privileges" [class.active]="setPrivilege">
          <ul>
            <li *ngFor="let privilege of privilegeSettings;">
              <app-manage-privilege
                [student]="student"
                [privilege]="privilege"
                [lesson]="lesson"
                [studentPrivilegeSettings]="studentsPrivileges">
              </app-manage-privilege>
            </li>
          </ul>
        </span>
      </li>
    </ul>
  </div>
</section>
